<script>
import newBidInput from "../components/form components/newBidInput";

export default {
  name: "bid-entry",
  components: {
    newBidInput,
  },
  data: function() {
    return {
      newBid: this.activeBid ? this.activeBid.currentRate - this.minIncrement : null,
    };
  },
  methods: {
    onModalClose: function() {
      this.$store.commit("setBidModalVisible", false);
    },
    async updateBid() {
      await this.$store.dispatch("setBidAmount", this.newBid);
      this.onModalClose();
    },
  },
  computed: {
    currency: function() {
      return this.$store.state.activeAuction.currency;
    },
    activeBid: function() {
      return this.$store.state.activeBid || null;
    },
    minIncrement: function() {
      return this.$store.state.activeAuction.minIncrement;
    },
    bidFormatted: function() {
      return `${this.newBid.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,")} ${this.currency}`;
    },
    currentBidFormatted: function() {
      return this.activeBid ? `${this.currency} ${this.activeBid.currentRate.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,")}` : "";
    },
    minDecrimentDisplay: function() {
      var self = this;
      return `${self.minIncrement} ${self.currency}`;
    },
    bidLimitDisplay: function() {
      var self = this;
      return `${self.minIncrement} ${self.currency}`;
    },
    showBidEntry: function() {
      return this.$store.state.bidModalVisible;
    },
    amountTooHigh: function() {
      if (!this.activeBid) {
        return false;
      }
      return isNaN(this.newBid) || this.newBid > this.activeBid.currentRate - this.minIncrement;
    },
    amountTooLow: function() {
      return this.newBid < this.minIncrement;
    },
  },
  watch: {
    activeBid: {
      handler: function(val) {
        if (val) {
          var self = this;
          self.newBid = val.currentRate - self.minIncrement;
        }
      },
      deep: true,
    },
  },
};
</script>
<template>
  <div v-if="activeBid !== null">
    <b-modal id="bid-entry-modal" :title="`Enter Bid Amount (${activeBid.vesselName})`" v-model="showBidEntry" v-on:hidden="onModalClose">
      <div class="row">
        <div class="col-lg-12">
          <i>Current Bid Amount: {{ currentBidFormatted }}</i>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12">
          <span class="title-text">Bid Amount</span><br />
          <new-bid-input v-model="newBid" :inputValue="newBid == null ? null : parseInt(newBid)" :min="50" :formatAsCurrency="true" :max="this.activeBid.currentRate" :currentBid="activeBid.currentRate"></new-bid-input>
          <i v-if="amountTooHigh" class="bid-alert"> Bid Amount must be at least {{ minDecrimentDisplay }} less than current bid</i>
          <i v-else-if="amountTooLow" class="bid-alert"> Bid Amount must be at least {{ bidLimitDisplay }}</i>
        </div>
      </div>
      <template v-slot:modal-footer="{ cancel }">
        <div class="row" style="width:100%">
          <div class="col-6" style="padding-left:0px;padding-right:5px;">
            <b-button class="button-full" style="float:left;" size="sm" variant="danger" v-on:click="cancel()">
              Cancel
            </b-button>
          </div>
          <div class="col-6" style="padding-right:0px;padding-left:5px;">
            <b-button class="button-full" :disabled="amountTooHigh || amountTooLow" size="sm" variant="success" v-on:click="updateBid()">
              Proceed
            </b-button>
          </div>
        </div>
      </template>
    </b-modal>
  </div>
</template>
<style scoped>
.context-text {
  font-size: 18px;
}
.title-text {
  font-size: 12px;
}
.bid-alert {
  color: red;
  font-size: 12px;
}
.button-full {
  width: 100%;
}
</style>
